










export enum EcgAnalysisSetTypeEnum {

	Overread = "EAS_OVERREAD",

	Review = "EAS_REVIEW",

	QC = "EAS_QC_OVERREAD",

}